import { useEffect } from "react";
import ErrorBlock from "../ErrorBlock";
import { Pinterest } from "./Pinterest";
import { IBlockComponentProps } from "../_Block";
import NotificationManager from "../../../notifications/NotificationManager";
import BlockScroller from "../BlockScroller";

interface IPinterestBlockProps extends IBlockComponentProps {
  blockObj: IPinterestBlockObj;
}

export function ParsePinterestURL(url: string) {
  const pinterestregex = new RegExp("^((http|https)://)?[w]*.pinterest.com/");
  const pinregex = new RegExp("^pin\\/[\\w]+\\/");
  const categories = new RegExp("^ideas\\/[\\w]+\\/.*");
  let embedType = "";

  if (pinterestregex.test(url)) {
    let subUrl = url.replace(pinterestregex, "");

    if (pinregex.test(subUrl)) {
      embedType = "embedPin";
    } else if (categories.test(subUrl)) {
      const message =
        "Pinterest does not currently support embedding ideas. Please try another URL";
      NotificationManager.error(message);
    } else {
      subUrl = subUrl.trim();
      if (subUrl.substring(subUrl.length - 1) == "/") {
        subUrl = subUrl.substring(0, subUrl.length - 1);
      }

      const arr = subUrl.split("/");
      if (arr[1] == "_saved" || arr[1] == "_created") {
        embedType = "embedUser";
      } else {
        embedType = "embedBoard";
      }
    }
  } else {
    const message = "The url '{" + url + "}' is not a valid Pinterest URL";
    NotificationManager.error(message);
  }
  return embedType;
}

export default function PinterestBlock(props: IPinterestBlockProps) {
  try {
    useEffect(() => {
      function buildPinterest() {
        var url;
        if (props.blockObj.blockModel.jsonObj != null) {
          url = props.blockObj.blockModel.jsonObj.block.settings.url;
        } else {
          url = props.blockObj.blockModel.json_data.block.settings.url;
        }
        var pinterestObj = new Pinterest(
          props.htmlId,
          `#pin_container_${props.htmlId}`,
          url,
          ParsePinterestURL(url),
        );

        pinterestObj.build();
      }
      // @ts-ignore
      if (typeof PinUtils === "undefined") {
        import(
          /* webpackMode: "lazy" */
          "pinterest-widgets/pinit_main"
        ).then(buildPinterest);
      } else {
        buildPinterest();
      }
    }, []);

    return (
      <BlockScroller
        blockRef={props.blockRef}
        blockObj={props.blockObj}
        setShowExpandButton={props.setShowExpandButton}
        outsideGrid={props.outsideGrid}
      >
        <div className="sb-blockContent" style={{ padding: 0, height: "100%" }}>
          <div
            id={`pin_container_${props.htmlId}`}
            className="sb-pinterest-link text-center"
          />
        </div>
      </BlockScroller>
    );
  } catch (error) {
    return <ErrorBlock blockObj={{ errorMessage: error }} />;
  }
}
